import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Image12 from '../../../assests/database.jpeg';

const Databasemanagement= () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Database Management & Integration"
          src={Image12}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Database Management & Integration
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Database Design and Development:</strong> Structuring databases for optimal performance and scalability.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Data Migration:</strong> Transferring data between systems or formats.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Database Optimization:</strong> Enhancing database performance through indexing, query optimization, and caching.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Backup and Recovery:</strong> Setting up regular backups and disaster recovery plans.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Database Security:</strong> Implementing encryption, access controls, and auditing.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Database Integration:</strong> Connecting databases with applications and third-party services.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Data Warehousing:</strong> Creating data warehouses for analytics and reporting.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Cloud Database Solutions:</strong> Implementing and managing cloud-based databases (e.g., AWS RDS, Firebase).
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Databasemanagement;
